import { useQuery } from '@apollo/client'
import { GetClearanceStatusByUser, GetClearanceStatusByUserVariables } from '../../types'
import { GET_CLEARANCE_STATUS_BY_USER } from './operations'

export const useClearanceStatusByUser = ({
  userId,
  groupId,
}: {
  userId: string
  groupId: string
}) =>
  useQuery<GetClearanceStatusByUser, GetClearanceStatusByUserVariables>(
    GET_CLEARANCE_STATUS_BY_USER,
    {
      variables: { filterData: { userId, groupId } },
    }
  )
